import {Component, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {QuestionnaireFieldConfig} from '@shared/models/common.models';
import {DataMappingSourceOption} from '@features/data-mapping/models/data-mapping.model';


@Component({
    standalone: false,
    selector: 'app-select-data-mapping-source-dialog',
  templateUrl: './select-data-mapping-source-dialog.component.html',
  styleUrls: ['./select-data-mapping-source-dialog.component.scss']
})
export class SelectDataMappingSourceDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  selectedSource: QuestionnaireFieldConfig;
  sourceOption: DataMappingSourceOption;
  returns: 'single' | 'list';
  selectedItem: any;
  selectedItems: any;

  constructor() {
  }

  ngOnInit(): void {
    this.returns = this.data.input.returns ?? 'list';
  }

  onOkClicked(): boolean {
    if (this.sourceOption && this.sourceOption.id === 'itp-fields') {
      this.data.input.selectedSource = this.selectedSource;
      return true;
    }
    if (this.sourceOption && this.sourceOption.id === 'questionnaire') {
      if (this.returns === 'single') {
        this.data.input.relativePath = this.selectedItem.relativePath;
        this.data.input.fileName = this.selectedItem.name;
      } else {
        const names = this.selectedItems.map(o => o.name);
        this.data.input.relativePath = this.selectedItems.map(o => o.relativePath);
        this.data.input.fileName = names;
      }
      return true;
    }
    return false;
  }

  onSelectionChange($event: any) {
    const {sourceOption, selectedSource, selectedItems, selectedItem} = $event;
    this.sourceOption = sourceOption;
    this.selectedSource = selectedSource;
    this.selectedItems = selectedItems;
    this.selectedItem = selectedItem;
  }
}
